import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import "../../styles/survey-form/survey-form.scss";
import api, { authGuard, isAuthCancelled } from "../../middleware/api";
import FormAnimation from "../form-animation/form-animation";
import Heart from "../../assets/done_heart.gif";
import Failed from "../../assets/failed.gif";
import { CircularProgress } from "@mui/material";
import { reportValidationErrors } from '../../utils/tracker-diagnostics';

const SurveyForm = ({ data }) => {
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [message, setMessage] = useState("");
  const [apiStatus, setApiStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const getIpAndCountry = async () => {
    try {
      const response = await fetch("https://ipapi.co/json/");
      const data = await response.json();
      return {
        ipAddress: data.ip || "Unknown",
        country: data.country_name || "Unknown",
      };
    } catch (error) {
      console.warn("Could not fetch IP/Country:", error);
      return { ipAddress: "Unknown", country: "Unknown" };
    }
  };

  const onSubmitAddQRForm = async (formData) => {
    const isCurrent = authGuard();
    const payload = {
      ...data,
      mobile_number: `${data.country_code} ${data.mobile_number}`.trim(),
      survey_ans: formData.default_message,
    };
    delete payload.country_code;

    const imageFile = payload.image?.[0];
    delete payload.image;

    const registrationData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        registrationData.append(key, value);
      }
    });

    if (imageFile) {
      registrationData.append("image", imageFile);
    }

    const API = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/qrcode/register`;
    setLoading(true);

    try {
      const { ipAddress, country } = await getIpAndCountry();
      if (!isCurrent()) return;
      registrationData.append("ipAddress", ipAddress);
      registrationData.append("country", country);
      await api.post(API, registrationData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (!isCurrent()) return;
      setMessage("You are all set - hooray!");
      setApiStatus(200);
      setLoading(false);
    } catch (error) {
      if (!isCurrent() || isAuthCancelled(error)) return;
      setMessage("Something has gone wrong,don't worry. let's try again.");
      setApiStatus(500);
      setLoading(false);
    }

    setIsFormSubmitted(true);
  };
  
  return (
    <div className="login-container form-icon">
      {isFormSubmitted ? (
        <FormAnimation icon={apiStatus === 200 ? Heart : Failed} heading={message} showQrCodeIcon={apiStatus === 200 ? false : true} />
      ) : (
        <div>
          <div className="survey-form">
            <div className="header-title">
              <h1>Activate QR</h1>
              <Link to="/qr-scanner" className="close-menu">
                X
              </Link>
            </div>

            <form onSubmit={handleSubmit(onSubmitAddQRForm, errors => reportValidationErrors(errors, 'registration_survey'))} className="survey-form-list">
              <div className="form-group-login textarea-group">
                <p>For warranty purposes, could you please let us know where you purchased your Roam and share the last seven digits of your Amazon order number, or the last four digits for other order numbers?</p>
                <textarea
                  rows="4"
                  className="survey-form-text"
                  name="default_message"
                  placeholder="E.g. Amazon 1234567, Roam website 1203, Walmart 8882, etc."
                  {...register("default_message", {
                    required: "This field is required",
                  })}
                />
                {errors.default_message && (
                  <span className="error-message">{errors.default_message.message}</span>
                )}

              </div>
              <button className="login-button">
                {loading ? <CircularProgress size={25} sx={{ color: "white", display: "flex", alignItems: "center", justifyContent: "center", margin: "auto" }} /> : <span>Save</span>}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default SurveyForm;
